export const getters = {
  currentUser(state) {
    return state.user;
  },
  game(state) {
    return state.game;
  },

  gifts(state) {
    return state.gifts;
  },

  histories(state) {
    return state.histories;
  },

  historyByLangPage(state) {
    return (page, lang) => {
      let historyByLang = state.historyByLangAndPage[lang];
      if (typeof historyByLang === "undefined") {
        return historyByLang;
      }
      return historyByLang[page];
    };
  },

  totalHistory(state) {
    return state.totalHistory;
  },

  winGift(state) {
    return state.winGift;
  },

  isShowing(state) {
    return state.isShowing;
  },
};
